import { render } from "./productMarketDetail.vue?vue&type=template&id=600f2eac&scoped=true"
import script from "./productMarketDetail.vue?vue&type=script&lang=js"
export * from "./productMarketDetail.vue?vue&type=script&lang=js"

import "./productMarketDetail.vue?vue&type=style&index=0&id=600f2eac&lang=scss&scoped=true"

import exportComponent from "/Users/jinjing/Desktop/jj/code1/HM0518/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600f2eac"]])

export default __exports__